import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_996syxfhau: FaireBrandEntity = {
  token: "b_996syxfhau",
  type: "brand",
  name: "Gospel Gear Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8e98f55b65a769baf9d78a1fd049fa2a00c6e4baefa8ab15d6a3b5ed49d843f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/75fc60643227574d3b0efaf2421ad4fffeb09ef4e0d1087d840e3d39b4304838.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c8e98f55b65a769baf9d78a1fd049fa2a00c6e4baefa8ab15d6a3b5ed49d843f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/75fc60643227574d3b0efaf2421ad4fffeb09ef4e0d1087d840e3d39b4304838.jpeg",
  location: "Marietta , OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 54,
  isTopShop: true,
  isInsider: true,
  description:
    "How was Gospel Gear Co born? At the beginning of 2021 I began having very detailed dreams about this business; from the brand name, to the logo, and items we now carry. I ignored them for a few weeks but continued to have them almost nightly. At the time I was following my “dreams” working as a large animal veterinary technician and never imagined I would ever make clothing or own a boutique. On a leap of faith I decided to start listening to what God was very clearly telling me through my dreams. The rest of the story has been a whirlwind of blessings. I now run my shop full time and am blessed to say that all of the things God showed me in my dreams have come to fruition. We have sold Gear in all 50 states and 24 countries across the globe to date. He is good. He is faithful. And most of all He is patient.\n\nOur mission is simple : Spread the Gospel in every item we sell and give Him all the glory along the way.\n\nWelcome to Gospel Gear Company. Always remember, God never goes out of style.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.214Z",
    importedBy: "entity-db-cli",
  },
};
